import React from "react";
import styled from "styled-components";

import Modal from "../../Core/Modal/Modal";
import AppText from "../../Core/AppText/AppText";
import { useTranslation } from "react-i18next";
import Button from "../../Core/Button/Button";
import Flex from "../../Layout/Flex";

interface ModalParamProps {
	title?: string;
	bodyText: string;
	onCancel: () => any;
	isLoading?: boolean;
	onConfirmation?: () => any;
	maxWidth?: string;
	confirmButtonText?: string;
	cancelButtonText?: string;
}

const SimpleConfirmationModal: React.FC<ModalParamProps> = ({
	title,
	bodyText,
	isLoading,
	onCancel,
	onConfirmation,
	maxWidth,
	confirmButtonText,
	cancelButtonText,
}) => {
	const { t } = useTranslation();

	return (
		<Modal maxWidth={maxWidth ? maxWidth : "518px"} padding="3.125rem 4rem 3.125rem 4rem">
			{title && (
				<AppText size="xm" weight="bold" margin="0 0 33px 0">
					{t(title as any) || title}
				</AppText>
			)}
			<Flex direction="column" alignItems="center">
				<AppText size="m" margin="0 0 33px 0">
					{t(bodyText as any) || title}
				</AppText>
			</Flex>
			<ModalButtonWrapper>
				<Button
					onClick={onConfirmation}
					width="144px"
					margin="0 0 0 0"
					fontSize="s"
					height="34px"
					loading={isLoading}
				>
					{confirmButtonText ? confirmButtonText : t("YES")}
				</Button>
				<Button
					onClick={onCancel}
					width="144px"
					margin="0.625rem 0 0 0"
					textColor="black"
					backgroundColor="buttonGray"
					fontSize="s"
					height="34px"
				>
					{cancelButtonText ? cancelButtonText : t("NO")}
				</Button>
			</ModalButtonWrapper>
		</Modal>
	);
};

export default SimpleConfirmationModal;

const ModalButtonWrapper = styled.div`
	display: flex;
	align-items: center;
	flex-direction: column;
`;
